export const mutations = {
  SetTheme: "SetTheme",
  SetLayout: "SetLayout",
};
